import { OpenDataKpiReport, WaterProvider } from "../misc";
import { Unit, ValueStatus, ValueStatusDomain } from "./kpiReport.types";
import { KpiReport } from "./kpiReport.types";
import _ from "lodash";

const unitConvertingOldToNewLabel = {
    "per 100 km sewer mains": "per 100 km sewer main",
    "per 100 km water mains": "per 100 km water main"
};

export const getKpiReportFromOpenDataResult = (
    providers: WaterProvider[],
    entities?: OpenDataKpiReport[]
): KpiReport[] => {
    const nameToProvider = _.keyBy(providers, d => d.kapiName);
    return (entities ?? [])
        .map(
            ({
                // "Scheme ID": schemeId,
                Value: value,
                Comments: comments,
                Scheme: scheme,
                "Indicator Title": indicatorTitle,
                "KPI Code": kpiCode,
                "Scheme Type": schemeType,
                Organisation: providerName,
                Units: unit,
                Year: year,
                _id: tid,
                ...props
            }) => {
                // const provider = nameToProvider?.[providerName] as WaterProvider;
                unit = unitConvertingOldToNewLabel?.[unit] ?? unit;

                const _value =
                    // value === NA && provider?.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk
                    //     ? null
                    //     :
                    _.isNaN(parseFloat(value)) ? null : parseFloat(value);

                const _year = _.isNaN(parseFloat(year)) ? 0 : parseFloat(year);
                const _valueStatus =
                    // value === NA && provider?.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk
                    //     ? null
                    //     :
                    ValueStatusDomain?.[value?.toLowerCase()?.trim()] === 1
                        ? (value?.toLowerCase()?.trim() as ValueStatus)
                        : null;

                const _valueStatusN =
                    // value === NA && provider?.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk
                    //     ? null
                    //     :
                    ValueStatusDomain?.[value?.trim()] === 1 ? (value?.trim() as ValueStatus) : null;

                const schemeId = props["Scheme Id"] ?? props["Scheme ID"]

                return {
                    provider: nameToProvider?.[providerName],
                    kpiCode,
                    // organisation: providerName,
                    organisation: providerName,
                    name: _.join([providerName, schemeId, kpiCode, _year], " - "),
                    schemeId,
                    schemeType,
                    status: true,
                    tid,
                    weight: tid,
                    year: _year,
                    value: _value,
                    valueStatus: _valueStatusN ?? _valueStatus,
                    comment:
                        comments != null && comments.trim() !== ""
                            ? {
                                  value: comments,
                                  processed: comments,
                                  format: comments
                              }
                            : null,
                    indicatorTitle,
                    scheme,
                    unit: unit as Unit
                };
            }
        )
        ?.filter(d => d.year == null || d.year > 2015);
};
